import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';

import {environment} from '../../environments/environment';

 @Component({
    changeDetection: ChangeDetectionStrategy.OnPush,
    selector: 'app-footer',
    templateUrl: './footer.component.html',
    styleUrls: ['./footer.component.scss'],
    standalone: false
})
export class FooterComponent implements OnInit {

  certiplateAdminVer = environment.version;
  constructor() { }

  ngOnInit(): void {
    
  }

}
